import { cryptoCurrenciesMetaSelector } from 'components/features/rewards/rewardsPane/store/selectors/currencies'
import { CurrenciesMetaGetMetaInfoRequestAction } from 'components/features/rewards/rewardsPane/store/actions/currenciesMeta'
import { SimpleGuard } from 'interfaces/guards'

export const cryptoMetaGuard: SimpleGuard = {
  name: `Crypto Rewards Currencies Static Meta Data Guard`,
  checker: (state): boolean => {
    const cryptoMeta = cryptoCurrenciesMetaSelector(state)
    return Boolean(cryptoMeta?.allKeys.length)
  },
  loader: (dispatch) => {
    dispatch(new CurrenciesMetaGetMetaInfoRequestAction())
  },
}
